// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","TagsRow":"TagsRow_yXRPe","Tag":"Tag_aaABH"};